import { render, staticRenderFns } from "./area-select.vue?vue&type=template&id=069ddc46&scoped=true&"
import script from "./area-select.vue?vue&type=script&lang=js&"
export * from "./area-select.vue?vue&type=script&lang=js&"
import style0 from "./area-select.vue?vue&type=style&index=0&id=069ddc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069ddc46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('069ddc46')) {
      api.createRecord('069ddc46', component.options)
    } else {
      api.reload('069ddc46', component.options)
    }
    module.hot.accept("./area-select.vue?vue&type=template&id=069ddc46&scoped=true&", function () {
      api.rerender('069ddc46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AreaSelect/area-select.vue"
export default component.exports